/**
 * 视频声音开关。按钮与 video 通过 data-video-id 绑定，点击时按 id 匹配找到 video 并切换静音。
 * 状态只存在 class is-unmuted 上，初始为静音。
 */
(function () {
  /**
   * 根据 muted 更新按钮展示（class 控制图标）
   * @param {HTMLElement} btn
   * @param {boolean} muted - true=静音（关），false=未静音（开）
   */
  function setDisplayState(btn, muted) {
    if (muted) {
      btn.classList.remove('is-unmuted');
    } else {
      btn.classList.add('is-unmuted');
    }
  }

  /**
   * 若按钮带 data-video-id，按 id 匹配找到 video，切换静音并更新按钮 class
   * @param {HTMLElement} btn
   * @returns {boolean} 是否执行了
   */
  function applyDefaultBehavior(btn) {
    var videoId = btn.getAttribute('data-video-id');
    if (!videoId) return false;
    var candidates = document.querySelectorAll('video[data-video-id]');
    var video = null;
    for (var i = 0; i < candidates.length; i++) {
      if (candidates[i].getAttribute('data-video-id') === videoId) {
        video = candidates[i];
        break;
      }
    }
    if (!video) return false;
    var currentMuted = !btn.classList.contains('is-unmuted');
    var newMuted = !currentMuted;
    video.muted = newMuted;
    setDisplayState(btn, newMuted);
    return true;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.video-sound-toggle-btn');
    if (!btn) return;
    applyDefaultBehavior(btn);
  });

  /** 初始：全部为静音展示 */
  function init() {
    document.querySelectorAll('.video-sound-toggle-btn').forEach(function (btn) {
      setDisplayState(btn, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
